import React, { Component } from 'react';
import { Col, Panel } from 'react-bootstrap';
import moment from 'moment';

class NextDraft extends Component {

  render() {
    return (
      <Col sm={6}>
        <Panel header={<h1>Next Event</h1>} bsStyle="primary">
          <h3>The <a href="https://games.crossfit.com/" target="_blank" rel="nofollow">Crossfit Games</a> on Aug 1st, 2017</h3>
          <h4 className="login-text">Drafting begins in about {moment().to([2017, 6, 15], true)} after Regionals are over and the complete list of Games athletes are chosen.</h4>
        </Panel>
      </Col>
    );
  }

}

export default NextDraft;



// WEBPACK FOOTER //
// ./src/components/Home/NextDraft.js